import Http from './http';
import Cookies from "js-cookie";
const prefix = '/user';

export const getUser = () => {
  const officeToken = Cookies.get('officeToken')
  //console.log('officeToken', officeToken)
  const params = officeToken ? `?office_token=${officeToken}` : ''
  return Http.authApi().get(`${prefix}${params}`)
};
export const update = (user, complete = '') => {
  if (complete) { return Http.authApi().put(`${prefix}/complete`, user) } else { return Http.authApi().put(`${prefix}`, user) }
};



// WEBPACK FOOTER //
// ./src/js/services/user.js